import React from 'react';

import { Translator } from 'ggApp/modules/translator';

import MasterCardIcon from 'ggApp/shared/icons/MasterCard';
import VisaIcon from 'ggApp/shared/icons/Visa';
import AmexIcon from 'ggApp/shared/icons/AmericanExpress';
import SepaIcon from 'ggApp/shared/icons/Sepa';
import PayPalIcon from 'ggApp/shared/icons/PayPal';

import { ParagraphText } from './styles';

// TODO: add single card headers for existing card payments.
export const CardHeader = () => (
    <>
        <MasterCardIcon />
        <VisaIcon />
        <AmexIcon />
        <ParagraphText>
            <Translator tk="NEW_CHECKOUT_PAYMENT_METHOD_CARD" />
        </ParagraphText>
    </>
);

export const SepaHeader = () => (
    <>
        <SepaIcon />
        <ParagraphText>
            <Translator tk="NEW_CHECKOUT_PAYMENT_METHOD_SEPA" />
        </ParagraphText>
    </>
);

export const PayPalHeader = () => (
    <>
        <PayPalIcon />
        <ParagraphText>
            <Translator tk="NEW_CHECKOUT_PAYMENT_METHOD_PAYPAL" />
        </ParagraphText>
    </>
);
